<neo-notificacion #notificacion></neo-notificacion>
<form #formElement [formGroup]="formValidators" novalidate class="formContacto" [class]="class">
    <fieldset>
        <neo-input [label]="'Nombre'" [controlCampo]="formValidators.controls['nombre']">
        </neo-input>
        <neo-input [tipo]="'tel'" [label]="'Teléfono'" [controlCampo]="formValidators.controls['telefono']">
        </neo-input>
        <neo-input [label]="'Email'" [controlCampo]="formValidators.controls['email']">
        </neo-input>
        <neo-textarea-contador [label]="'Mensaje'" [controlCampo]="formValidators.controls['mensaje']">
        </neo-textarea-contador>
    </fieldset>
    <div class="form-bottom">
        <div class="form-bottom-blq1">
            <neo-captcha *ngIf="solicitarCaptcha" #captcha [controlCampo]="formValidators.get('captcha')"></neo-captcha>
        </div>
        <div class="form-bottom-blq2">
            <div class="form-multiple">
                <neo-campo-checkbox class="form-campo-checkbox" [clase]="'mat-checkbox-lg'"
                    [controlCampo]="formValidators.get('politica_privacidad')" [color]="'black'" [label]="'He leído y acepto la '"
                    [labelLink]="{texto: 'Política de privacidad',rutaInterna: '/aviso-legal'}">
                </neo-campo-checkbox>
                <neo-campo-checkbox class="form-campo-checkbox" [clase]="'mat-checkbox-lg'"
                    [controlCampo]="formValidators.get('comunicacionesComerciales')" [color]="'black'"
                    [label]="'No deseo recibir comunicaciones comerciales.'">
                </neo-campo-checkbox>
            </div>
        </div>
        <div class="form-bottom-blq3">
            <neo-button class="button-block button-width" [text]="'Enviar'" [color]="'primary'" [flat]="true" [type]="'submit'">
            </neo-button>
        </div>
    </div>
</form>